import { render, staticRenderFns } from "./EstablishmentViewIstheraProducts.vue?vue&type=template&id=51a1ca4a"
import script from "./EstablishmentViewIstheraProducts.vue?vue&type=script&lang=js"
export * from "./EstablishmentViewIstheraProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports